<script>
import Layout from "../../layouts/auth";
import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import { error_message, success_message } from "../../../state/helpers";

/**
 * Forgot Password component
 */
export default {
  page: {
    title: "Forgot Password",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      form: {
        email: "",
        role: "Admin",
      },
    };
  },
  validations: {
    form: {
      email: { required, email },
    },
  },
  methods: {
    ...mapActions("user", ["ForgotPassword"]),
    resetPassword() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        this.ForgotPassword(this.form).then((response) => {
          if (response.data.code === 200) {
            console.log("response", response);
            success_message(response.data.msg);
            this.$router.push({ name: "login" });
          } else {
            error_message(response.data.msg);
          }
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Reset Password</h5>
                  <p>Re-Password with Sonik Mobility.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img src="@/assets/images/profile-img.png" alt class="img-fluid" />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/sonic-logo-icon.png" alt height="34" />
                  </span>
                </div>
              </router-link>
            </div>
            <div class="p-2">
              <form @submit.prevent="resetPassword">
                <div class="form-group">
                  <label for="useremail">Email</label>
                  <input
                    type="email"
                    v-model="form.email"
                    class="form-control"
                    id="useremail"
                    placeholder="Enter email"
                    :class="{ 'is-invalid': $v.form.email.$error }"
                  />
                  <div v-if="$v.form.email.$error" class="invalid-feedback">
                    <span v-if="!$v.form.email.required">Email is required.</span>
                    <span v-if="!$v.form.email.email">Please enter valid email.</span>
                  </div>
                </div>
                <div class="form-group row mb-0">
                  <div class="col-12 text-right">
                    <button class="btn btn-primary w-md" type="submit">Reset</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>
            Remember It ?
            <router-link tag="a" to="/login" class="font-weight-medium text-primary"
              >Sign In here</router-link
            >
          </p>
          <p>© {{ new Date().getFullYear() }} Sonik Mobility.</p>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
